import React from 'react';
import { Trans } from '@lingui/react/macro';
import styled from 'styled-components';

import Flex from '@rover/kibble/core/Flex/Flex';
import Heading from '@rover/kibble/core/Heading/Heading';
import MQ from '@rover/kibble/styles/MediaQuery';
import CaptionedImage, {
  Container as CaptionedImageContainer,
  DesktopCard,
} from '@rover/react-lib/src/components/images/CaptionedImage';
import PageLayout from '@rover/react-lib/src/components/layouts/PageLayout';
import sitterDesktop from '@rover/shared/images/policies/guarantee/rg_lp_photo_01_desktop.jpg';
import sitterMobile from '@rover/shared/images/policies/guarantee/rg_lp_photo_01_mobile.jpg';
import sitterTablet from '@rover/shared/images/policies/guarantee/rg_lp_photo_01_tablet.jpg';
import inject from '@rover/utilities/injector';

import { SPAN_BRAND_2_COLORS_STYLES } from '../brand2ColorStyles.constants';

const { veterinaryCareLimit } = inject('Rover.context', '');
const GreenSpan = styled.span`
  ${SPAN_BRAND_2_COLORS_STYLES}
`;
const ResponsivePageLayout = styled(PageLayout)`
  margin-bottom: ${({ theme }) => theme.space['0x']};
  margin-top: ${({ theme }) => theme.space['0x']};
`;
const CaptionedImageWrap = styled.div`
  position: relative;
`;
const StyledCaptionedImage = styled(CaptionedImage)`
  margin-bottom: ${({ theme }) => theme.space['24x']};
  ${MQ.XS.toString()} {
    margin-bottom: ${({ theme }) => theme.space['16x']};
    flex-direction: column-reverse;
  }

  ${CaptionedImageContainer} {
    ${MQ.MD_UP.toString()} {
      background-image: url(${sitterDesktop});
      height: 408px;
    }

    ${MQ.XS.toString()} {
      height: 300px;
      background-image: url(${sitterMobile});
    }

    ${MQ.SM.toString()} {
      height: 350px;
      background-image: url(${sitterTablet});
    }

    border-radius: ${({ theme }) => theme.radii.primary};
    background-size: cover;
    background-position: center;
  }

  ${DesktopCard} {
    hr {
      background-color: ${({ theme }) => theme.colors.green[700]};
      height: ${({ theme }) => theme.space['1x']};
      border-radius: ${({ theme }) => theme.radii.primary};
      width: 74px;
    }

    width: 404px;
    left: 65px;
    top: -35px;
    box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.12);
    border-radius: ${({ theme }) => theme.radii.primary};
  }
`;

const CaptionedImageSection = (): JSX.Element => (
  <Flex justifyContent="center" data-testid="captioned-image-section">
    <ResponsivePageLayout>
      <CaptionedImageWrap>
        {/* @ts-expect-error this is a deliberate omission of the imageSrc prop, the styles above supply the image as a background */}
        <StyledCaptionedImage position="top-left">
          <Heading size="400" textColor="primary" mb="0x">
            <Trans>
              Every booking made on the platform is backed by the Rover Guarantee, which includes up
              to
            </Trans>{' '}
            <GreenSpan>
              <Trans comment="{veterinaryCareLimit} is the total amount limit for the veterinary care.">
                {veterinaryCareLimit} in vet care
              </Trans>
            </GreenSpan>{' '}
            <Trans>for eligible claims.</Trans>
          </Heading>
        </StyledCaptionedImage>
      </CaptionedImageWrap>
    </ResponsivePageLayout>
  </Flex>
);

export default CaptionedImageSection;
